var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5C0 4.44772 0.447715 4 1 4L19 4C19.5523 4 20 4.44772 20 5C20 5.55228 19.5523 6 19 6L1 6C0.447715 6 0 5.55228 0 5Z",
    fill: "#E35252"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.20818 1.20818C7.98177 0.434593 9.03098 0 10.125 0C11.219 0 12.2682 0.434593 13.0418 1.20818C13.8154 1.98177 14.25 3.03099 14.25 4.125V4.75C14.25 5.30229 13.8023 5.75 13.25 5.75H7C6.44772 5.75 6 5.30229 6 4.75V4.125C6 3.03099 6.43459 1.98177 7.20818 1.20818Z",
    fill: "#E35252"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5C2 4.44772 2.44772 4 3 4H17C17.5523 4 18 4.44772 18 5V16.3333C18 17.2659 17.6771 18.1827 17.0692 18.8775C16.4575 19.5765 15.5971 20 14.6667 20H5.33333C4.40291 20 3.54246 19.5765 2.93084 18.8775C2.32294 18.1827 2 17.2659 2 16.3333V5ZM7 8C7.55228 8 8 8.44772 8 9V15C8 15.5523 7.55228 16 7 16C6.44772 16 6 15.5523 6 15V9C6 8.44772 6.44772 8 7 8ZM14 9C14 8.44772 13.5523 8 13 8C12.4477 8 12 8.44772 12 9V15C12 15.5523 12.4477 16 13 16C13.5523 16 14 15.5523 14 15V9Z",
    fill: "#E35252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.50d2683368563feaba691e57371901b8.svg";
export { ForwardRef as ReactComponent };